import axios from 'axios/index';
import ApiError from '../errors/api';

class BaseApi {
  METHOD_POST = 'POST';
  METHOD_GET = 'GET';

  ERROR_CODE = 'SYSTEM_ERROR';
  ERROR_MESSAGE = 'Service temporary unavailable';

  /**
   * @param {string} url
   * @param {number} timeout
   */
  constructor(url, timeout) {
    this.url = url;
    this.timeout = timeout;
  }

  /**
   * @param {string} method
   * @param {string} path
   * @param {string} token
   * @param params
   * @returns {Promise<*>}
   */
  async makeRequest(method, path, token, params) {
    const url = `${this.url}/${path}`;
    const headers = {'Content-Type': 'application/json'};

    if (typeof token === 'string') {
      headers['Authorization'] = token;
    }

    const config = {
      method,
      url,
      responseType: 'json',
      headers,
      data: params,
    };

    try {
      const response = await axios(config);

      return this.parseResponse(response);
    } catch (e) {
      if (e instanceof ApiError) {
        throw e;
      }

      const response = typeof e.response !== 'undefined' ? e.response : {};
      const data = typeof response.data !== 'undefined' ? response.data : {};
      const code = typeof data.code === 'string' ? data.code : this.ERROR_CODE;
      const message = typeof data.message === 'string'
        ? data.message
        : this.ERROR_MESSAGE;

      throw new ApiError(message, code);
    }
  }

  /**
   * @param {Response} response
   */
  parseResponse(response) {
    if (typeof response.data === 'undefined') {
      throw new ApiError('Invalid response', this.ERROR_CODE);
    }

    if (typeof response.data.code !== 'string') {
      throw new ApiError('No code in response data', this.ERROR_CODE);
    }

    if (response.data.code !== 'OK') {
      throw new ApiError('Invalid code in response data', this.ERROR_CODE);
    }

    if (typeof response.data.result === 'undefined') {
      throw new ApiError('No result in response data', this.ERROR_CODE);
    }

    return response.data.result;
  }
}

export default BaseApi;
